import React from 'react'
import parse from 'html-react-parser';

const Legalese = ({text}) => (
  <div className="legalese">
    {parse(text)}
  </div>
)

export default Legalese
